/// <amd-module name="Analytics/Boards/BurndownQueries/BurndownQueryBase" />
import { AnalyticsCacheableQueryBase } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { BatchRequestMode, ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";

/** Provides bookkeeping tracking for all Ax queries owned by Burndown Widget. */
export abstract class BurndownQueryBase<T> extends AnalyticsCacheableQueryBase<T> {
    /** Used to identify Analytics Service traffic requested by this widget in Kusto */
    public static readonly Command: string = "Burndown";

    constructor(queryOptions: ODataQueryOptions, command?: string) {
        const extendedQueryOptions: ODataQueryOptions = {
            ...queryOptions,
            batchRequestMode: BatchRequestMode.Enabled
        };
        super(command ? command : BurndownQueryBase.Command, extendedQueryOptions);
    }
}
